import {openResourceModal} from '../../core/modalCommand';
import {
	EOGRE_PROFILE_CREATE_MODAL_EVENT,
	EOGRE_PROFILE_DELETE_MODAL_EVENT,
	EOGRE_PROFILE_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open the Add EoGRE form, with nothing filled in.
 *
 * This resource maps no fields: the agent opens the empty form and the
 * person completes it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openEoGREProfileCreateModal(command, envelope) {
	return openResourceModal(EOGRE_PROFILE_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit EoGRE profile for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openEoGREProfileEditModal(command, envelope) {
	return openResourceModal(EOGRE_PROFILE_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Delete EoGRE profile confirmation.
 *
 * The confirmation, not the deletion. Nothing is removed until the person
 * presses the button inside it, which is why this capability is declared
 * destructive rather than read: a read capability would be worked
 * automatically, and this one must not be.
 *
 * Canvas refuses some of these itself - a profile still attached to an
 * SSID or a Site cannot be deleted - and says so in its own words. That
 * refusal is left to Canvas rather than guessed at here.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openEoGREProfileDeleteModal(command, envelope) {
	return openResourceModal(EOGRE_PROFILE_DELETE_MODAL_EVENT, command, envelope);
}
